/**
 * Viewer 对 cad-core 全局 Worker runtime 的独占租约。
 *
 * 设计说明：
 * 1. 当前 cad-core 仍使用模块级共享 WorkerManager，因此同一时刻只能有一个 Viewer 驱动 Worker；
 * 2. 这里不引入 ownerId/runtimeGeneration，也不让多个 Viewer 静默共用 Worker；
 * 3. 第二个 Viewer 必须等待当前 Viewer dispose/release，或者在构造阶段收到明确错误。
 */
export class ViewerWorkerRuntimeLease {
    /** 当前占用全局 Worker runtime 的 Viewer 对象。 */
    private activeOwner: object | null = null;

    /**
     * 获取全局 Worker runtime 使用权。
     *
     * @param owner 申请使用权的 Viewer 实例。
     */
    public acquire(owner: object): void {
        if (this.activeOwner === owner) {
            return;
        }

        if (this.activeOwner) {
            throw new Error('全局 Worker 已被另一个 Viewer 占用，请先 dispose 当前 Viewer 后再创建新的 Viewer');
        }

        this.activeOwner = owner;
    }

    /**
     * 释放全局 Worker runtime 使用权。
     *
     * @param owner 释放使用权的 Viewer 实例。
     */
    public release(owner: object): void {
        if (this.activeOwner !== owner) {
            return;
        }

        this.activeOwner = null;
    }
}

/**
 * cad-core 当前共享 Worker runtime 的 Viewer 级租约。
 */
export const viewerWorkerRuntimeLease = new ViewerWorkerRuntimeLease();
